/* Reading progress for Headroom's "Continue reading" tile (sections/rm-hub.liquid). Net-new, not stock Concept.
   Loaded on article pages by layout/theme.liquid. Remembers how far down the article body (.rm-article)
   the reader has got, in this browser only. Nothing is sent anywhere.
   Stored under "rm-reading" as up to 8 entries: { u: path, t: title, i: image URL, m: minutes, p: percent, d: time }.
   An article read to 90% counts as finished and drops off the list. */

(() => {
  const body = document.querySelector('.rm-article');
  if (!body) return;

  const KEY = 'rm-reading';
  const MAX_ENTRIES = 8;
  const FINISHED = 90;

  const load = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  };

  const save = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      // Storage is blocked or full; nothing to do.
    }
  };

  const meta = (property) => document.querySelector(`meta[property="${property}"]`)?.getAttribute('content') || '';

  // The meta tag is "https:" + image_url, which is "//domain/cdn/…" on the live site but a bare "/cdn/…" path on
  // `shopify theme dev`. Drop a scheme glued to a bare path, then resolve against the page.
  let image = '';
  try {
    const raw = (meta('og:image:secure_url') || meta('og:image')).replace(/^https?:(?=\/[^/])/, '');
    if (raw) {
      const url = new URL(raw, window.location.href);
      url.searchParams.set('width', '200');
      image = url.href;
    }
  } catch (error) {
    image = '';
  }

  const entry = {
    u: window.location.pathname,
    t: meta('og:title') || document.title,
    i: image,
    m: Math.max(1, Math.ceil(body.textContent.replace(/\s+/g, ' ').trim().length / 1380)),
    p: load().find((saved) => saved.u === window.location.pathname)?.p || 0,
    d: Date.now(),
  };

  let changed = false;
  let queued = false;

  const measure = () => {
    queued = false;
    const rect = body.getBoundingClientRect();
    if (rect.height <= 0) return;
    const percent = Math.max(0, Math.min(100, ((window.innerHeight - rect.top) / rect.height) * 100));
    if (percent > entry.p + 1) {
      entry.p = percent;
      changed = true;
    }
  };

  // Measures again before saving: animation frames pause in background tabs, so the last scroll may not be counted yet.
  const commit = () => {
    measure();
    if (!changed) return;
    changed = false;
    entry.d = Date.now();
    const list = load().filter((saved) => saved.u !== entry.u);
    if (entry.p < FINISHED) list.unshift(entry);
    save(list.slice(0, MAX_ENTRIES));
  };

  window.addEventListener(
    'scroll',
    () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    },
    { passive: true }
  );
  window.addEventListener('pagehide', commit);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') commit();
  });
  window.setInterval(commit, 5000);
})();
